export default {
    init() {
      // JavaScript to be fired on the company us page
      /* const teamOverlay = $('.section-team--overlay');
      const container = $('.team-container');
      const expand = $('.team_expand');
      $('.team_item').click((e) => {
          teamOverlay.show();
          expand.css('width', container.width());
          $(e.target).closest('.team_item').addClass('team_item--active');
          $('.team_item--active .team_expand').show()
          $('html').css('overflow','hidden');
      })

      $('.team_expand_close').click((e) => {
        e.stopPropagation()
        teamOverlay.hide();
        $('.team_item--active .team_expand').hide()
        $(e.target).closest('.team_item').removeClass('team_item--active');
        $('html').css('overflow','auto');
     }) */
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/company.js